module.exports = __webpack_public_path__ + "img/feature_buy_ph.73c7aa60.png";